import React from "react";

import { Project } from "../../models/monitoring-models";

const MonitoringContext = React.createContext<Project[]>([]);

export const MonitoringProvider = MonitoringContext.Provider;
export const MonitoringConsumer = MonitoringContext.Consumer;
export default MonitoringContext;
